/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import type { BarChart, PieChart } from '@trinity/chat';

export const barToPie = (data: BarChart): PieChart => {
  return {
    title: data.title,
    xAxisTitle: data.xAxisTitle,
    yAxisTitle: data.yAxisTitle,
    data: data.data.map(point => ({
      id: point.x,
      label: point.x,
      value: point.y,
    })),
  };
};

export const pieToBar = (data: PieChart): BarChart => {
  return {
    indexBy: data.xAxisTitle,
    title: data.title,
    xAxisTitle: data.xAxisTitle,
    yAxisTitle: data.yAxisTitle,
    data: data.data.map(point => ({
      x: point.label,
      y: point.value,
    })),
  };
};